import React from 'react';
import OrderItem from "./OrderItem";
import {ChevronRight} from 'lucide-react';
import MonthSelector from "./MonthSelector";
import {useNavigate} from "react-router-dom";
import {PATH} from "../../constants";

const OrderList = ({orders, selectedMonth, onMonthChange, isOpen, setIsOpen}) => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate(PATH.MANAGING_ORDER)
  }
  const onHandleClick = (item) => {
    navigate(`${PATH.MANAGING_ORDER}?status=${item?.status}`)
  }
  return (
    <div className="mt-4 bg-white rounded-lg md:rounded-xl text-sm p-4">
      <div className="flex justify-between items-center mb-4">
        <div className='flex items-center space-x-2'>
          <div className="font-normal">Tổng số đơn hàng</div>
          <div className='font-bold text-xl'>{orders?.total || 0}</div>
        </div>
        <MonthSelector
          selectedMonth={selectedMonth}
          onMonthChange={onMonthChange}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      </div>
      <div className="space-y-3">
        {orders.items.map((item, index) => (
          <OrderItem key={index} {...item} onHandleClick={() => onHandleClick(item)}/>
        ))}
      </div>
      <button
        onClick={handleRedirect}
        className="w-full mt-4 py-2 text-center text-gray-600 hover:bg-gray-50 rounded-lg flex items-center justify-center">
        <span>Xem tất cả đơn hàng</span>
        <ChevronRight className="w-4 h-4 ml-1"/>
      </button>
    </div>
  )
};
export default OrderList;